module.exports = __webpack_public_path__ + "media/images/awards/award-top-hero-a8146ce313d3e3d491d2b529209fae05.png";